<template>
	<div class="input-content">
		<!-- Label container -->
		<div class="flex gap-1">
			<label
				v-if="props.label"
				:for="props.id"
				:class="[
					'tv__input-label',
					props.size === 'sm' ? 'tv__input-sm-label' : '',
				]"
			>
				{{ props.label }}
			</label>
			<!-- label tooltip -->
			<TVTooltip
				v-if="props.tooltipMessage"
				:max-width-tooltip="props.tooltipMaxWidth"
				:float-tooltip-mobile="props.tooltipDirMobile"
				:float-tooltip-desk="props.tooltipDirDesk"
			>
				<template #title>
					<p v-html="props.tooltipMessage" />
				</template>
			</TVTooltip>
		</div>

		<!-- checkbox content-->
		<div class="content-radio-button">
			<div
				v-for="(option, index) in options"
				:key="index"
				class="tv__radio-button"
			>
				<RadioButton
					v-model="selectedValue"
					:value="option.value"
					:input-id="option.id"
					:label="option.label"
					@click="emitValue && handleChange"
					class="notranslate"
					translate="no"
				></RadioButton>
				<label :for="option.id" class="tv__radio-button-label">
					{{ option.label }}
				</label>
			</div>
		</div>

		<!-- Error message -->
		<span class="input-message-content">
			<small
				v-if="props.customErrorMessage || errorMessage"
				class="text-red-500 text-xs flex"
			>
				<i class="tv__input-icon tv__input-icon-error" />
				{{ props.customErrorMessage || errorMessage }}
			</small>
		</span>
	</div>
</template>

<script setup>
import { toRef, watch, defineProps, defineEmits } from 'vue'
import RadioButton from 'primevue/radiobutton'
import { useField } from 'vee-validate'
import TVTooltip from '../global/TVTooltip.vue'

const props = defineProps({
	id: String,
	tooltipMessage: String,
	label: String,
	options: Array,
	errorMessage: String,
	tooltipDirDesk: String,
	tooltipDirMobile: String,
	tooltipMaxWidth: Number,
	name: String,
	modelValue: Array,
	customErrorMessage: String,
	error: Boolean,
	size: {
		type: String,
		default: 'lg',
		validator: (value) => ['lg', 'sm'].includes(value),
	},
})

const emits = defineEmits(['update:modelValue'])

const {
	value: selectedValue,
	errorMessage,
	handleChange,
} = useField(toRef(props, 'name'), undefined, {
	initialValue: props.modelValue,
})

watch(
	() => props.modelValue,
	(newValue) => {
		if (newValue !== undefined) {
			selectedValue.value = newValue
		}
	},
)

watch(selectedValue, (newValue) => {
	if (newValue !== undefined) {
		emits('update:modelValue', newValue)
	}
})

function emitValue() {
	emits('update:modelValue', selectedValue.value)
}
</script>
